/*
 *   Copyright (c) 2025 LoginID Inc
 *   All rights reserved.

 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at

 *   http://www.apache.org/licenses/LICENSE-2.0

 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import { CheckoutExternalPage } from "./pages/checkout/external";
import { createTheme, MantineProvider } from "@mantine/core";
import { Navigate, Route, Routes } from "react-router-dom";
import { CheckoutPage } from "./pages/checkout";
import DiscoverPage from "./pages/discover";
import BankingPage from "./pages/banking";
import "@mantine/core/styles.css";
import "./App.css";
import { AuthCallback } from "./pages/interac/AuthCallback";
import { AgentCheckout } from "./pages/agent/AgentCheckout";
import { VTSEnrole } from "./pages/vts/VTSEnrole";
import { TestCheckoutPage } from "./pages/checkout/test/TestPage";
import { AgenticTestCheckoutPage } from "./pages/agentic/checkout/test/TestPage";
import { AgenticCheckoutPage } from "./pages/agentic/checkout";
import { LoginPage } from "./pages/oauth2/LoginPage";
import { ConsentPage } from "./pages/oauth2/ConsentPage";
import { PaymentHandlerPage } from "./pages/oauth2/PaymentHandlerPage";
import { ClientPage } from "./pages/oauth2/ClientPage";
import { CallbackPage } from "./pages/oauth2/CallbackPage";

const brand = process.env.REACT_APP_BRAND || "Paze";
//const scheme = process.env.REACT_APP_SCHEME || "dark";
const theme = createTheme({
  /** Put your mantine theme override here */

  primaryColor: `${brand}`,
  colors: {
    'Paze': ["#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8"],
    'AWallet': ["#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688"],
    'Konek': ["#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA"],
    'Interac': [
      "#fff8df",
      "#ffefca",
      "#ffde99",
      "#ffcc63",
      "#ffb92a",
      "#ffb318",
      "#ffae03",
      "#e49800",
      "#cb8700",
      "#b07300"],
    'Cookies': [
      "#f3edff",
      "#e0d7fa",
      "#beabf0",
      "#9a7de6",
      "#7c55de",
      "#693cd9",
      "#5f30d8",
      "#4f23c0",
      "#461eac",
      "#3b1898"
    ],
  }

});

function App() {
  return (
    <div className="App">
      <MantineProvider theme={theme} defaultColorScheme="auto">
        <Routes>
          <Route path="/" element={<CheckoutPage />} />
          <Route path="/test" element={<TestCheckoutPage />} />
          <Route path="/vts" element={<VTSEnrole />} />
          <Route path="/idv" element={<DiscoverPage />} />
          <Route path="/oauth2/test" element={<ClientPage />} />
          <Route path="/oauth2/callback" element={<CallbackPage />} />
          <Route path="/oauth2/login" element={<LoginPage />} />
          <Route path="/oauth2/consent" element={<ConsentPage />} />
          <Route path="/oauth2/payment/:id" element={<PaymentHandlerPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout/:id" element={<CheckoutPage />} />
          <Route path="/banking" element={<BankingPage />} />
          <Route path="/external" element={<CheckoutExternalPage />} />
          <Route path="/agent/checkout/:id" element={<AgentCheckout />} />
          <Route path="/interac/callback/:consentId" element={<AuthCallback />} />
          <Route path="/agentic/test" element={<AgenticTestCheckoutPage />} />
          <Route path="/agentic/checkout" element={<AgenticCheckoutPage />} />
          <Route path="/agentic/checkout/:id" element={<AgenticCheckoutPage />} />
        </Routes>
      </MantineProvider>
    </div>
  );
}

export default App;
